import { Centered, EllipsedText, MaterialIcon } from '@gorila-shared-ui/components';
import { Button } from 'baseui/button';
import { LoadingSpinner } from 'baseui/button/styled-components';
import { ListItem, ListItemLabel } from 'baseui/list';
import { CSSProperties, memo } from 'react';
import { ListChildComponentProps } from 'react-window';
import { ASSET_TYPE } from '../../../constants/asset';
import { Asset } from '../../../types/asset';
import { capitalize } from '../../../utils/strings';

function AssetItem({
  data,
  index,
  style,
}: Readonly<
  ListChildComponentProps<{
    assets: Asset[];
    type: 'selectable' | 'deselectable';
    onClick: (assetId: string) => void;
    isLoaded: (index: number) => boolean;
  }>
>) {
  const asset: Asset | undefined = data.assets[index];

  return (
    <span style={style as CSSProperties}>
      {!asset && ( // Out of range, this element allows to get more items.
        <Centered>
          <LoadingSpinner $size="xSmall" />
        </Centered>
      )}
      {!!asset && (
        <ListItem
          endEnhancer={() => (
            <Button
              size="mini"
              shape="round"
              kind="tertiary"
              onClick={() => data.onClick(asset._id)}
            >
              <MaterialIcon
                name={data.type === 'selectable' ? 'add' : 'remove'}
                size="mini"
              />
            </Button>
          )}
        >
          <ListItemLabel description={asset.assetType ? capitalize(ASSET_TYPE[asset.assetType] || '') : undefined}>
            <EllipsedText inline>{asset?.label || '-'}</EllipsedText>
          </ListItemLabel>
        </ListItem>
      )}
    </span>
  );
}

export default memo(AssetItem);
